export const downloadFileInPWA = async (file, fileName) => {
    const getFile = await fetch(file);
    const blob = await getFile.blob();
    const a = document.createElement("a");

    a.href = window.URL.createObjectURL(new Blob([blob]));
    a.setAttribute("download", `${fileName}`);
    a.click();
};
